import React from "react";
import logo from "./logo.svg";
import python from "./python.svg";
import linux from "./linux.svg";
import javascript from "./javascript.svg";
import typescript from "./typescript.svg";
import stackoverflow from "./stackoverflow.svg";
import twitter from "./twitter.svg";
import dribble from "./dribble.svg";
import Octocat from "./Octocat.png";
import Ishaan from "./Ishaan.png";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <img src={Ishaan} className="Self-logo" alt="logo" />
          <p
            style={{
              marginTop: "40vh",
              border: "4px solid #61dafb",
              borderRadius: "20px",
              padding: "5px",
            }}
          >
            @championrunner
          </p>
          <div>
            <img src={logo} className="App-logo" alt="logo" />
            <img src={python} className="Python-logo" alt="logo" />
            <img src={linux} className="Linux-logo" alt="logo" />
            <img src={javascript} className="Javascript-logo" alt="logo" />
            <img src={typescript} className="Typescript-logo" alt="logo" />
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "20vh",
            }}
          >
            <h1>Ishaan Malik</h1>
            <a
              className="App-link"
              href="https://www.linkedin.com/in/himalik/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learning
            </a>
            <a
              className="App-link"
              href="https://github.com/Ishaan28malik"
              target="_blank"
              rel="noopener noreferrer"
            >
              Building
            </a>
            <a
              className="App-link"
              href="https://medium.com/simply-dev"
              target="_blank"
              rel="noopener noreferrer"
            >
              Writing
            </a>
            <p>Contact Me</p>
            <a
              className="App-link"
              href="https://twitter.com/ChampionRunner"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                style={{ height: "30px", width: "40px" }}
                src={twitter}
                alt="logo"
              />
            </a>
            <a
              className="App-link"
              href="ishaanmalikrm7@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Email Me!
            </a>
          </div>
          <div style={{ marginLeft: "20vh" }}>
            <p>I contribute to</p>
            <p>
              Open Source{" "}
              <a
                className="App-link"
                href="https://github.com/Ishaan28malik"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{ height: "40px", width: "40px" }}
                  src={Octocat}
                  alt="logo"
                />
              </a>{" "}
              on regular basis and
            </p>
            <p>
              ask questions and answer questions on{" "}
              <a
                className="App-link"
                href="https://stackoverflow.com/users/11422830/champion-runner"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{ height: "40px", width: "40px" }}
                  src={stackoverflow}
                  alt="logo"
                />
              </a>{" "}
              every week
            </p>
            <p>
              and design things{" "}
              <a
                className="App-link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://dribbble.com/championrunner"
              >
                <img
                  style={{ height: "40px", width: "40px" }}
                  src={dribble}
                  alt="logo"
                />
              </a>{" "}
              sometimes I like to travel and meet hackers
            </p>
            <p>around the world and you will find me playing sports</p>
            <p> if I m not working.....</p>
            {/* <p>
              I design things sometimes
              <a
                className="App-link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://dribbble.com/championrunner"
              >
                <img
                  style={{ height: "40px", width: "40px" }}
                  src={dribble}
                  alt="logo"
                />
              </a>
            </p> */}
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
